import { useMemo } from 'react';
import { buildAppNavItems } from './appNavigationConfig';
import { useAppNavAccess } from './useAppNavAccess';

export function useAppNavItems() {
  const navAccess = useAppNavAccess();
  const navItems = useMemo(() => buildAppNavItems(navAccess), [navAccess]);

  return { navItems, navAccess };
}
